import React from 'react';
import { bool, func } from 'prop-types';
import noop from 'lodash/noop';

import { adBlockMessage } from '../util/status';
import { replaceTags } from '../util/messages';

import Notice from './Notice';

const AdBlockMessage = ({ openWhyPremiumDialog, nightModeEnabled }) => (
  <div className="adblock-message" style={{ marginBottom: 16 }}>
    <Notice icon="favorite_border" nightModeEnabled={nightModeEnabled}>
      {replaceTags(adBlockMessage, openWhyPremiumDialog, noop)}
    </Notice>
  </div>
);

AdBlockMessage.propTypes = {
  openWhyPremiumDialog: func,
  nightModeEnabled: bool
};

export default AdBlockMessage;
